import React, { useCallback } from "react";

// Component for rendering task progress bar
function ProgressBar({ task, displayRemaining }) {
  const progressWidth = task.duration
    ? ((displayRemaining || 0) / task.duration) * 100
    : 100;
  const progressRatio = task.duration
    ? Math.min(Math.max((displayRemaining || 0) / task.duration, 0), 1)
    : 1;

  // Memoized color interpolation
  const interpolateColor = useCallback((ratio) => {
    const clampedRatio = Math.min(Math.max(ratio, 0), 1);
    const colors = [
      { ratio: 0, r: 220, g: 53, b: 69 },
      { ratio: 0.5, r: 255, g: 193, b: 7 },
      { ratio: 1, r: 40, g: 167, b: 69 },
    ];
    let startColor, endColor;
    if (clampedRatio <= 0.5) {
      startColor = colors[0];
      endColor = colors[1];
    } else {
      startColor = colors[1];
      endColor = colors[2];
    }
    const t =
      clampedRatio <= 0.5 ? clampedRatio / 0.5 : (clampedRatio - 0.5) / 0.5;
    const r = Math.round(startColor.r + t * (endColor.r - startColor.r));
    const g = Math.round(startColor.g + t * (endColor.g - startColor.g));
    const b = Math.round(startColor.b + t * (endColor.b - startColor.b));
    return `rgb(${r}, ${g}, ${b})`;
  }, []);

  const progressColor = interpolateColor(progressRatio);

  return (
    <div className="progress-bar">
      <div
        className="progress-fill"
        style={{
          width: `${progressWidth}%`,
          backgroundColor: progressColor,
        }}
      ></div>
    </div>
  );
}

export default ProgressBar;
